import React from "react";
import {PropTypes} from "prop-types";

import copy from "../copy";
import {ValidatedInput} from "../../components/validated-input";
import {validateIntegerString} from "../../utils/validation";

export function OtherIncomeAmountField(props) {
    return (
        <ValidatedInput
            {...copy.other_income_gross_amount}
            validator={val => validateIntegerString(val, 1)}
            {...props}
            type="currency"
        />
    );
}

OtherIncomeAmountField.propTypes = {
    value: PropTypes.string,
    error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    onChange: PropTypes.func,
    controlId: PropTypes.string,
};
